var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _g2, _path43, _g3, _path44, _path45, _path46, _g4, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigital(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 660,
    viewBox: "0 0 640 660",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6128_38784)"
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 150.166,
    y1: 5.32551e-8,
    x2: 150.166,
    y2: 534,
    stroke: "#F8F7FF",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 277.389,
    y1: 5.32551e-8,
    x2: 277.389,
    y2: 534,
    stroke: "#F8F7FF",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 404.611,
    y1: 5.32551e-8,
    x2: 404.611,
    y2: 534,
    stroke: "#F8F7FF",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 531.834,
    y1: 5.32551e-8,
    x2: 531.834,
    y2: 534,
    stroke: "#F8F7FF",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 90,
    x2: 40,
    y2: 90,
    stroke: "#F8F7FF",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 328.52,
    x2: 40,
    y2: 328.52,
    stroke: "#F8F7FF",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 209.26,
    x2: 40,
    y2: 209.26,
    stroke: "#F8F7FF",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 640,
    y1: 447.78,
    x2: 40,
    y2: 447.78,
    stroke: "#F8F7FF",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_6128_38784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M599.596 351.646C626.676 367.299 626.82 392.701 599.915 408.354L369.784 542.26C342.88 557.913 299.111 557.913 272.031 542.26L40.4123 408.354C13.3323 392.701 13.1725 367.315 40.0766 351.662L270.208 217.74C297.112 202.087 340.897 202.087 367.977 217.74L599.596 351.63V351.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.596 351.646C626.676 367.299 626.82 392.701 599.915 408.354L369.784 542.26C342.88 557.913 299.111 557.913 272.031 542.26L40.4123 408.354C13.3323 392.701 13.1725 367.315 40.0766 351.662L270.208 217.74C297.112 202.087 340.897 202.087 367.977 217.74L599.596 351.63V351.646Z",
    stroke: "#DDEFFF",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6128_38784)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M406.867 434C403.293 434 399.977 433.226 397.393 431.721L228.792 334.542C225.175 332.435 223.064 329.081 223.064 325.34C223.064 321.255 225.519 317.514 229.826 315.063L248.645 304.227C251.875 302.378 255.923 301.346 260.015 301.346C263.589 301.346 266.862 302.12 269.489 303.625L438.09 400.804C441.707 402.911 443.817 406.265 443.817 410.006C443.817 414.091 441.363 417.832 437.056 420.283L418.237 431.119C415.007 432.968 410.959 434 406.867 434Z",
    fill: "#BECEE9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M251.057 426.045C243.262 430.517 230.601 430.517 222.763 426.002C214.925 421.487 214.882 414.177 222.677 409.705C230.472 405.233 243.133 405.233 250.971 409.748C258.809 414.263 258.852 421.573 251.057 426.045Z",
    fill: "#C2C5CD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M325.259 319.148L382.794 352.516C382.062 352.086 381.115 352 380.038 352.344C379.608 352.473 379.177 352.645 378.746 352.903L321.211 319.535C321.642 319.277 322.115 319.062 322.503 318.976C323.536 318.675 324.484 318.718 325.259 319.148Z",
    fill: "#1F79FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M377.281 353.978L319.746 320.61L319.918 320.223L377.411 353.591L377.281 353.978Z",
    fill: "#1F79FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M378.746 352.903C379.177 352.645 379.651 352.43 380.038 352.344C382.536 351.57 384.431 353.075 384.431 356.171C384.431 359.783 381.89 364.169 378.746 365.975C376.765 367.136 375.043 366.964 374.009 365.76C373.535 365.201 373.191 364.427 373.105 363.481C373.105 363.223 373.062 362.965 373.062 362.707C373.062 359.697 374.827 356.128 377.239 353.978C377.713 353.548 378.186 353.204 378.703 352.903H378.746Z",
    fill: "#888B90"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M377.411 353.591L319.918 320.223L285.38 236.675L342.915 270.043L377.411 353.591Z",
    fill: "#1F79FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M374.741 366.362L317.206 332.994C316.947 332.822 316.689 332.65 316.517 332.392C316.043 331.833 315.699 331.059 315.612 330.113C315.612 329.855 315.569 329.597 315.569 329.339C315.569 326.329 317.335 322.76 319.747 320.61C320.22 320.18 320.694 319.836 321.211 319.535L378.746 352.903C378.229 353.204 377.756 353.548 377.282 353.978C374.87 356.128 373.105 359.697 373.105 362.707C373.105 362.965 373.105 363.223 373.148 363.481C373.277 364.427 373.578 365.201 374.052 365.76C374.267 366.018 374.483 366.19 374.741 366.362Z",
    fill: "#BABCBF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M373.147 363.481L315.612 333.467L270.135 359.654C269.144 360.213 268.369 361.03 267.853 361.89L266.991 361.675V365.029C266.991 367.136 268.025 369.243 270.092 370.447L309.281 393.193C314.837 396.418 321.641 396.418 327.197 393.193L374.353 366.018L373.061 363.395L373.147 363.481Z",
    fill: "#888B90"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M315.612 330.113L270.135 356.3C265.958 358.708 265.958 364.728 270.135 367.136L309.324 389.882C314.88 393.107 321.684 393.107 327.24 389.882L373.104 363.438L315.569 330.07L315.612 330.113Z",
    fill: "url(#paint0_linear_6128_38784)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M345.197 267.721L380.123 352.215C379.65 352.43 379.219 352.645 378.788 352.903C378.272 353.204 377.798 353.548 377.324 353.978L377.453 353.591L342.958 270.043L345.24 267.721H345.197Z",
    fill: "#1F79FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M342.915 270.043L285.38 236.675L287.662 234.353L345.198 267.721L342.915 270.043Z",
    fill: "#1F79FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M225.605 22.2791L227.242 23.182L437.056 144.14L435.42 143.237L225.605 22.2791Z",
    fill: "#1F79FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M225.218 22.064C225.778 22.365 226.337 22.666 226.897 23.01C227.027 23.053 227.113 23.139 227.242 23.182L225.605 22.279C225.605 22.279 225.347 22.15 225.261 22.064H225.218Z",
    fill: "#1F79FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M446.617 353.978L439.382 358.149C442.353 356.429 444.205 352.731 444.205 347.528L451.44 343.357C451.44 348.56 449.588 352.258 446.617 353.978Z",
    fill: "#818489"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M451.957 171.832L452 169.94L451.483 341.422V343.314L451.957 171.832Z",
    fill: "#1F79FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M444.722 176.046L451.957 171.832L451.483 343.314L444.248 347.528L444.722 176.046Z",
    fill: "url(#paint1_linear_6128_38784)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M435.42 143.237L437.056 144.14C445.325 148.913 452 160.48 451.957 169.94V171.832C451.957 161.297 444.55 148.483 435.377 143.194L435.42 143.237Z",
    fill: "#818489"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M426.549 150.246C434.817 155.019 441.492 166.586 441.449 176.046L440.975 347.528C440.975 356.988 434.214 360.858 425.946 356.085L216.131 235.127C207.863 230.354 201.188 218.787 201.231 209.327L201.704 37.8449C201.704 28.342 208.466 24.515 216.734 29.288L426.549 150.246Z",
    fill: "url(#paint2_linear_6128_38784)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M381.158 139.539C380.254 140.098 379.392 140.743 378.66 141.474L227.932 54.0557L228.448 242.265L401.829 342.196L401.442 200.727C406.954 203.264 412.337 203.565 416.601 201.114C426.377 195.395 426.377 176.992 416.601 160.007C406.825 143.022 390.934 133.863 381.158 139.582V139.539Z",
    fill: "#818489"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M428.185 147.408L218.37 26.4501C209.197 21.1611 201.747 25.4181 201.704 35.91V37.8019C201.704 28.299 208.422 24.4721 216.691 29.245L426.505 150.203C434.774 154.976 441.449 166.543 441.406 176.003L440.932 347.485C440.932 356.816 434.343 360.686 426.247 356.214C426.807 356.515 427.366 356.816 427.926 357.16C436.927 362.105 444.205 357.848 444.205 347.485L444.679 176.003C444.679 165.468 437.315 152.654 428.142 147.365L428.185 147.408Z",
    fill: "url(#paint3_linear_6128_38784)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M435.42 143.237L225.605 22.279C220.997 19.6131 216.777 19.3551 213.762 21.1181L206.527 25.289C209.542 23.526 213.719 23.784 218.327 26.45L428.142 147.408C437.314 152.697 444.722 165.511 444.679 176.046L451.914 171.875C451.914 161.34 444.549 148.526 435.377 143.237H435.42Z",
    fill: "url(#paint4_linear_6128_38784)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M216.992 214.874L217.509 216.293C208.336 211.004 200.929 198.19 200.972 187.656L201.962 188.816C201.962 198.405 208.681 210.058 217.035 214.874H216.992Z",
    fill: "#1F79FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M201.919 188.817L200.929 187.656L201.359 44.6389L202.35 45.7999L201.919 188.817Z",
    fill: "#1F79FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M206.183 34.0179L208.379 32.7279C211.394 30.9649 215.571 31.2229 220.179 33.8889L217.983 35.1789C213.375 32.5129 209.197 32.2549 206.183 34.0179Z",
    fill: "#0066FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M202.35 45.7997L201.359 44.6387C201.359 34.1038 208.853 29.8899 218.026 35.1788L217.509 37.1998C209.154 32.3838 202.393 36.2538 202.35 45.8427V45.7997Z",
    fill: "#1F79FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M418.624 331.102L419.141 332.521L217.509 216.293L216.992 214.874L418.624 331.102Z",
    fill: "#1F79FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M433.18 332.392L430.983 333.682C433.955 331.962 435.807 328.264 435.807 323.061L438.003 321.771C438.003 327.017 436.151 330.672 433.18 332.392Z",
    fill: "#0066FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M433.783 322.459L435.764 323.018C435.764 333.553 428.271 337.767 419.098 332.478L418.581 331.059C426.936 335.875 433.697 332.005 433.74 322.416L433.783 322.459Z",
    fill: "#1F79FF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M436.194 180.044L438.391 178.754L438.003 321.771L435.807 323.018L436.194 180.044Z",
    fill: "#0066FF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M434.214 179.443L436.195 180.045L435.807 323.018L433.783 322.459L434.214 179.443Z",
    fill: "#1F79FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M217.509 37.1569L218.026 35.179L419.657 151.407L419.141 153.428L217.509 37.1569Z",
    fill: "#1F79FF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M218.025 35.1789L220.222 33.8889L421.854 150.117L419.657 151.407L218.025 35.1789Z",
    fill: "#0066FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M419.14 153.428L217.509 37.1568C209.154 32.3408 202.393 36.2108 202.35 45.7997L201.962 188.816C201.962 198.405 208.68 210.058 217.035 214.874L418.667 331.102C427.021 335.918 433.783 332.048 433.826 322.459L434.213 179.442C434.213 169.854 427.495 158.201 419.14 153.385V153.428Z",
    fill: "url(#paint5_linear_6128_38784)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M416.6 159.964C412.853 153.471 408.202 148.096 403.379 144.312L394.378 139.109C389.555 137.346 384.904 137.346 381.157 139.539C380.253 140.098 379.391 140.743 378.659 141.474L227.931 54.0557L228.404 221.453L401.785 321.384L401.441 200.727C406.953 203.264 412.336 203.565 416.6 201.114C426.376 195.395 426.376 176.991 416.6 160.007V159.964Z",
    fill: "#1F79FF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M419.141 153.428L419.657 151.407C428.83 156.696 436.238 169.51 436.195 180.044L434.213 179.485C434.213 169.897 427.495 158.244 419.141 153.428Z",
    fill: "#1F79FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M419.657 151.407L421.854 150.117C431.026 155.406 438.434 168.22 438.391 178.754L436.194 180.044C436.194 169.51 428.83 156.696 419.657 151.407Z",
    fill: "#0066FF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M257.345 228.376C257.948 227.172 258.249 226.226 258.249 225.538L257.345 228.376Z",
    fill: "#52586C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M398.34 364.77L224.959 264.194C222.461 262.603 221.04 259.379 221.04 255.165L394.421 355.784C394.421 359.998 395.842 363.18 398.34 364.813V364.77Z",
    fill: "url(#paint6_linear_6128_38784)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M394.421 355.784L221.04 255.165L220.48 58.3555L393.861 158.931L394.421 355.784Z",
    fill: "url(#paint7_linear_6128_38784)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M393.862 158.932L220.48 58.3555L222.935 56.9365L396.316 157.513L393.862 158.932Z",
    fill: "#E4E7ED"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M396.316 157.512L396.876 354.365C396.876 357.848 398.039 360.514 400.106 361.846L398.34 364.813C395.842 363.222 394.421 359.997 394.421 355.784L393.861 158.974L396.316 157.555V157.512Z",
    fill: "#E4E7ED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6128_38784",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 240,
    y: 231,
    width: 5,
    height: 3
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M240.118 232.719L241.453 232.16C242.314 231.816 243.348 231.902 244.425 232.504L243.09 233.063C242.013 232.461 240.979 232.332 240.118 232.719Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6128_38784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.118 232.719L241.453 232.16C242.314 231.816 243.348 231.902 244.425 232.504L243.09 233.063C242.013 232.461 240.979 232.332 240.118 232.719Z",
    fill: "#30A772"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6128_38784",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 359,
    y: 312,
    width: 4,
    height: 5
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M360.357 316.009L359.021 316.568C360.055 316.138 360.83 315.063 361.002 313.472L362.338 312.913C362.165 314.504 361.39 315.579 360.357 316.009Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6128_38784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.002 313.472L362.338 312.913C362.165 314.504 361.39 315.579 360.357 316.009L359.021 316.568C360.055 316.138 360.83 315.063 361.002 313.472Z",
    fill: "#30A772"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M243.09 233.063L244.425 232.504L359.366 298.766L358.031 299.325L243.09 233.063Z",
    fill: "#30A772"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M361.735 307.065L363.07 306.506L362.338 312.913L361.003 313.472L361.735 307.065Z",
    fill: "#30A772"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_6128_38784",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 358,
    y: 298,
    width: 6,
    height: 10
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M358.031 299.325L359.366 298.766C361.735 300.142 363.414 303.625 363.07 306.506L361.735 307.065C362.079 304.141 360.4 300.701 358.031 299.325Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_6128_38784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.031 299.325L359.366 298.766C361.735 300.142 363.414 303.625 363.07 306.506L361.735 307.065C362.079 304.141 360.4 300.701 358.031 299.325Z",
    fill: "#30A772"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M358.031 299.325C360.4 300.701 362.079 304.184 361.735 307.065L361.003 313.472C360.658 316.353 358.462 317.6 356.05 316.224L241.109 249.962C238.74 248.586 237.061 245.103 237.405 242.222L238.137 235.815C238.482 232.891 240.678 231.687 243.09 233.063L358.031 299.325Z",
    fill: "#00D158"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M281.202 269.183C280.858 268.71 280.599 268.194 280.427 267.635C280.255 267.076 280.255 266.517 280.384 265.915L281.719 266.689C281.676 267.119 281.719 267.549 281.891 267.979C282.064 268.409 282.365 268.71 282.796 268.968C283.226 269.226 283.571 269.269 283.872 269.14C284.174 269.011 284.346 268.71 284.432 268.28C284.518 267.936 284.475 267.635 284.389 267.334C284.26 267.033 284.131 266.775 283.915 266.517C283.7 266.259 283.442 265.958 283.054 265.614C282.58 265.141 282.236 264.754 281.934 264.367C281.676 264.023 281.461 263.593 281.288 263.077C281.159 262.561 281.116 262.002 281.245 261.357C281.375 260.755 281.547 260.325 281.848 260.024C282.15 259.723 282.537 259.551 282.968 259.551C283.399 259.551 283.915 259.68 284.432 259.981C285.164 260.411 285.724 261.013 286.112 261.787C286.499 262.561 286.629 263.378 286.499 264.281L285.121 263.464C285.164 263.077 285.121 262.69 284.906 262.303C284.734 261.916 284.432 261.572 284.002 261.357C283.657 261.142 283.313 261.099 283.054 261.228C282.796 261.357 282.58 261.615 282.494 262.088C282.451 262.389 282.494 262.69 282.58 262.991C282.667 263.292 282.839 263.55 283.054 263.765C283.269 264.023 283.528 264.324 283.872 264.668C284.346 265.141 284.734 265.571 284.992 265.915C285.294 266.302 285.509 266.732 285.638 267.248C285.767 267.764 285.81 268.323 285.638 268.968C285.552 269.484 285.337 269.914 285.035 270.215C284.734 270.559 284.346 270.731 283.915 270.774C283.485 270.774 282.968 270.688 282.451 270.387C281.934 270.086 281.504 269.699 281.159 269.226L281.202 269.183Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M289.902 263.249L288.61 269.699C288.437 270.473 288.48 271.118 288.696 271.677C288.911 272.236 289.299 272.666 289.858 272.967C290.418 273.268 290.849 273.354 291.237 273.139C291.624 272.924 291.883 272.451 292.055 271.72L293.39 265.313L294.639 266.044L293.304 272.408C293.131 273.225 292.873 273.827 292.485 274.214C292.098 274.601 291.667 274.816 291.15 274.859C290.634 274.859 290.117 274.73 289.557 274.429C288.997 274.128 288.523 273.698 288.136 273.139C287.748 272.623 287.49 271.978 287.318 271.29C287.188 270.559 287.188 269.828 287.318 269.011L288.61 262.604L289.858 263.335L289.902 263.249Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M300.194 275.633C300.366 276.278 300.409 276.879 300.28 277.438C300.151 277.954 299.979 278.341 299.677 278.599C299.376 278.9 299.031 279.029 298.601 279.029C298.17 279.029 297.696 278.9 297.223 278.599L294.208 276.836L296.361 266.861L299.29 268.538C299.807 268.839 300.237 269.226 300.582 269.656C300.926 270.086 301.142 270.559 301.228 271.075C301.314 271.591 301.314 272.064 301.228 272.537C301.098 273.096 300.883 273.526 300.539 273.784C300.194 274.042 299.85 274.128 299.419 274.085C299.806 274.429 300.108 274.902 300.28 275.547L300.194 275.633ZM296.663 271.892L298.213 272.795C298.644 273.053 298.988 273.096 299.247 272.967C299.548 272.838 299.72 272.58 299.806 272.107C299.893 271.677 299.85 271.247 299.677 270.86C299.505 270.473 299.204 270.172 298.816 269.914L297.266 269.011L296.62 271.892H296.663ZM298.471 277.438C298.773 277.309 298.988 277.008 299.074 276.536C299.204 276.063 299.161 275.59 298.945 275.16C298.773 274.73 298.428 274.386 298.041 274.128L296.404 273.182L295.715 276.277L297.395 277.267C297.825 277.525 298.17 277.567 298.471 277.438Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M311.391 275.633L308.98 285.436L307.731 284.705L309.367 277.998L305.448 283.372L304.587 282.856L303.812 274.773L302.262 281.523L301.013 280.793L303.252 270.903L304.63 271.677L305.491 281.008L310.013 274.816L311.348 275.59L311.391 275.633Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M314.32 277.31L311.865 287.114L310.616 286.383L313.028 276.579L314.277 277.31H314.32Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M320.951 281.137L320.607 282.469L318.583 281.309L316.43 289.736L315.181 289.005L317.334 280.578L315.267 279.374L315.611 278.041L320.994 281.137H320.951Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M245.458 419.122C245.458 419.122 243.606 421.014 243.477 421.788C243.348 422.562 243.305 423.895 243.477 424.626C243.649 425.357 246.491 427.206 248.3 427.206C250.109 427.206 257.861 423.035 259.497 422.304C261.134 421.573 266.431 419.681 268.153 418.52C269.876 417.316 272.632 414.435 272.589 412.285C272.546 410.178 270.651 408.458 268.929 408.501C267.206 408.587 245.458 419.079 245.458 419.079V419.122Z",
    fill: "#212430"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M213.418 417.273C213.03 418.391 212.815 420.369 212.729 421.186C212.643 422.003 212.729 422.691 213.418 423.25C214.15 423.809 216.518 424.669 219.791 423.852C223.064 423.035 225.605 417.66 226.94 416.069C228.275 414.478 230.988 413.145 232.969 411.382C234.95 409.619 236.931 406.695 236.759 404.803C236.544 402.911 236.415 401.578 235.123 401.793C233.831 402.008 213.461 417.273 213.461 417.273H213.418Z",
    fill: "#212430"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M213.331 410.135C213.331 410.135 212.729 414.865 212.729 416.886C212.729 418.907 212.944 420.584 213.03 421.143C213.116 421.702 214.839 422.992 218.542 422.562C222.246 422.132 224.356 417.058 225.433 415.983C226.509 414.908 229.825 411.898 231.979 410.78C234.132 409.662 236.113 405.921 236.156 404.416C236.156 402.911 236.156 401.922 235.209 401.535C234.261 401.148 229.438 401.406 227.328 401.535C225.217 401.664 218.887 404.803 218.887 404.803L213.331 410.135Z",
    fill: "#33374A"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M253.468 410.092C257.258 408.673 266.776 407.254 268.283 407.211C269.79 407.168 271.168 408.759 271.168 408.759C271.168 408.759 273.623 411.726 269.489 415.51C265.354 419.294 263.373 419.337 260.187 420.498C257 421.659 250.454 424.927 247.698 425.271C244.941 425.615 244.08 423.594 243.951 422.39C243.822 421.186 244.726 416.026 245.243 415.123C245.76 414.263 253.425 410.092 253.425 410.092H253.468Z",
    fill: "#33374A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M218.844 305.775C217.681 309.172 215.829 313.816 216.088 322.975C216.346 332.134 218.456 332.951 218.413 336.434C218.37 339.917 216.863 359.955 216.691 362.062C216.519 364.169 229.137 367.781 231.721 364.04C234.305 360.299 237.147 352.43 238.439 340.734C239.731 328.995 240.248 316.912 238.439 313.816C236.63 310.72 218.887 305.775 218.887 305.775H218.844Z",
    fill: "#363C53"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M228.318 312.698C225.347 322.76 225.734 326.759 228.318 333.295C230.902 339.874 236.328 343.357 236.328 343.357C236.328 343.357 236.716 371.823 238.654 378.401C240.592 384.98 252.995 382.787 254.287 378.401C255.579 374.015 261.995 346.84 261.608 334.714C261.22 322.588 260.445 315.536 259.024 312.698C257.603 309.86 228.318 312.698 228.318 312.698Z",
    fill: "#3B4157"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M221.213 359.396C221.213 359.396 218.715 358.45 216.648 362.105C214.581 365.76 211.825 374.145 211.222 381.67C210.619 389.194 213.16 406.867 213.03 411.511C217.595 414.908 224.313 411.984 224.443 406.781C224.572 401.578 227.974 372.554 232.711 362.449C229.697 357.246 221.256 359.439 221.256 359.439L221.213 359.396Z",
    fill: "#363C53"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M241.841 368.684C241.841 368.684 238.31 371.737 238.224 376.768C238.138 381.798 237.535 389.022 238.224 393.537C238.913 398.052 244.727 411.554 244.339 416.8C248.086 420.455 256.914 418.219 256.527 411.21C256.139 404.201 254.675 383.948 254.718 376.467C254.761 368.985 241.798 368.727 241.798 368.727L241.841 368.684Z",
    fill: "#3B4157"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M257.603 319.535C253.038 324.05 241.97 325.512 234.132 324.738C223.495 323.706 216.131 316.998 216.045 314.891C216.002 312.784 217.681 302.206 217.81 298.809C217.94 295.412 208.121 273.181 207.13 267.376C206.097 261.572 206.743 256.842 208.939 253.617C211.178 250.392 215.313 247.941 220.524 248.973C223.108 250.822 237.061 260.755 240.807 263.377C244.554 266 248.731 270.171 251.703 274.471C251.918 274.772 252.09 275.073 252.263 275.46C252.263 275.46 252.392 275.804 252.478 275.976C252.693 276.492 252.909 277.094 253.081 277.696C253.167 277.954 253.21 278.212 253.296 278.47C253.382 278.857 253.512 279.287 253.598 279.717C253.598 279.803 253.598 279.889 253.641 279.975C253.684 280.233 253.727 280.491 253.77 280.749C253.813 281.007 253.856 281.308 253.942 281.566C253.985 281.953 254.071 282.297 254.115 282.684C254.115 282.856 254.158 282.985 254.201 283.157C254.201 283.415 254.287 283.716 254.33 283.974C254.588 285.909 254.804 287.887 254.933 289.65C254.933 289.908 254.976 290.166 255.019 290.381C255.148 291.714 255.277 292.918 255.363 293.907C255.363 294.079 255.363 294.251 255.407 294.38C255.493 295.025 255.579 295.541 255.665 295.928C255.665 296.014 255.708 296.143 255.751 296.229C256.526 299.368 257.646 302.937 259.627 313.472C260.101 315.923 259.282 317.944 257.646 319.535H257.603Z",
    fill: "#EAEEF9"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M216.777 240.889C217.422 245.017 217.207 248.973 216.26 250.908C215.312 252.843 213.504 255.552 220.006 255.423C226.509 255.294 232.151 257.358 232.151 257.358C232.151 257.358 232.28 248.328 232.625 247.898C232.969 247.468 237.017 246.694 238.395 244.802C239.773 242.91 238.869 234.912 238.869 234.912C238.869 234.912 238.223 227.172 234.735 222.743C231.246 218.314 229.481 218.4 225.734 218.83C221.987 219.26 216.777 240.975 216.777 240.975V240.889Z",
    fill: "#FF9C78"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M231.936 227.129C228.706 231.343 232.366 233.063 232.754 235.041C233.142 237.019 232.323 240.975 232.323 240.975C232.323 240.975 230.859 237.406 228.232 237.621C225.605 237.836 224.701 240.717 224.399 243.34C224.098 245.963 223.064 247.554 222.418 247.984C221.772 248.414 217.121 246.78 217.121 246.78C217.121 246.78 209.628 246.909 205.58 240.244C201.532 233.579 202.393 225.366 210.231 220.249C218.069 215.132 222.332 215.433 228.749 217.755C232.582 219.647 233.4 221.066 233.572 222.485C233.658 223.431 233.658 224.936 231.979 227.129H231.936Z",
    fill: "#553012"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M229.653 239.599C228.619 237.664 229.265 237.363 227.801 237.32C226.337 237.277 225.476 239.513 226.251 241.491C227.026 243.469 229.265 244.114 230.041 243.168C230.816 242.222 229.61 239.599 229.61 239.599H229.653Z",
    fill: "#FF9C78"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M257.603 319.535C255.191 314.203 251.315 309.043 250.023 306.033C247.999 301.217 244.123 290.166 241.496 288.059C238.869 285.909 228.835 284.576 228.318 281.179C228.318 281.179 238.525 267.119 252.22 275.46C252.22 275.46 252.349 275.804 252.435 275.976C252.65 276.492 252.866 277.094 253.038 277.696C253.124 277.954 253.167 278.212 253.253 278.47C253.339 278.857 253.469 279.287 253.555 279.717C253.555 279.803 253.555 279.889 253.598 279.975C253.641 280.233 253.684 280.491 253.727 280.749C253.77 281.007 253.813 281.308 253.899 281.566C253.942 281.953 254.028 282.297 254.071 282.684C254.071 282.856 254.114 282.985 254.158 283.157C254.158 283.415 254.244 283.716 254.287 283.974C254.545 285.909 254.76 287.887 254.89 289.65C254.89 289.908 254.933 290.166 254.976 290.381C255.105 291.714 255.234 292.918 255.32 293.907C255.32 294.079 255.32 294.251 255.363 294.38C255.45 295.025 255.536 295.541 255.622 295.928C255.622 296.014 255.665 296.143 255.708 296.229C256.483 299.368 257.603 302.937 259.584 313.472C260.058 315.923 259.239 317.944 257.603 319.535Z",
    fill: "#CCD6F1"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M277.542 274.988C276.853 274.429 277.283 274.386 278.231 274.386C279.178 274.386 279.996 274.558 281.676 274.085C283.355 273.612 284.087 272.408 283.614 271.849C283.14 271.29 281.159 271.935 280.858 272.064C280.556 272.193 275.216 271.591 275.216 271.591L270.651 273.311C270.651 273.311 249.205 273.913 245.63 272.107C242.056 270.258 247.74 275.977 257.516 279.889C267.292 283.802 286.844 283.544 284.518 281.308C282.193 279.073 277.585 275.074 277.585 275.074L277.542 274.988Z",
    fill: "#FF9C78"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M236.76 284.361C236.76 284.361 256.914 293.563 265.527 295.498C274.141 297.433 268.585 283.974 266.604 282.985C264.623 281.996 252.823 275.719 250.627 273.612C248.431 271.505 244.899 268.495 244.899 268.495C244.899 268.495 232.367 276.665 236.803 284.361H236.76Z",
    fill: "#FF9C78"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M262.728 291.284C262.728 291.284 260.919 294.509 265.527 295.541C270.135 296.573 274.528 296.057 277.715 295.24C280.901 294.423 288.955 292.746 289.127 292.703C289.299 292.703 289.859 292.617 290.031 293.649C290.247 294.681 295.113 298.895 295.457 298.981C295.759 299.067 296.706 298.465 296.706 298.465C296.706 298.465 297.438 298.766 297.912 298.465C298.386 298.164 299.204 297.218 299.204 297.218C299.204 297.218 300.108 297.089 300.582 296.831C301.013 296.53 300.798 294.509 300.798 294.509C300.798 294.509 301.917 293.864 301.874 293.004C301.831 292.144 299.721 288.446 299.721 288.446C299.721 288.446 296.792 286.554 296.749 285.479C296.706 284.404 297.481 283.802 298.3 283.2C299.118 282.598 299.204 280.147 298.644 279.245C298.084 278.342 296.836 278.901 296.663 279.718C296.491 280.534 296.233 280.921 296.233 280.921C296.233 280.921 295.802 281.781 294.682 282.555C293.563 283.329 293.046 283.759 292.4 284.318C291.754 284.877 290.893 285.135 286.069 284.576C281.246 284.017 267.723 282.512 265.096 282.813C262.469 283.114 262.814 291.198 262.814 291.198L262.728 291.284Z",
    fill: "#FF9C78"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M227.802 261.658C223.151 264.496 220.395 271.72 222.246 276.751C224.098 281.825 237.922 285.652 237.922 285.652C237.922 285.652 246.621 272.408 248.861 271.247C242.1 265.7 238.87 260.067 227.802 261.658Z",
    fill: "#F8F7FB"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M210.49 235.815C209.284 227.602 198.474 225.925 194.598 234.74C187.536 250.865 216.26 265.399 189 273.483C205.193 279.202 220.352 274.515 213.633 256.627C208.982 244.2 206.226 237.234 210.49 235.815Z",
    fill: "#553012"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M241.626 117.394L338.049 172.993C340.374 174.326 342.269 172.907 342.269 169.811V168.736C342.269 165.64 340.374 162.028 338.049 160.652L241.626 105.053C239.3 103.72 237.405 105.139 237.405 108.235V109.31C237.405 112.406 239.3 116.018 241.626 117.394Z",
    fill: "#CFD8DB"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M241.626 151.88L371.037 226.484C373.363 227.817 375.257 226.398 375.257 223.302V222.227C375.257 219.131 373.363 215.519 371.037 214.143L241.626 139.539C239.3 138.206 237.405 139.625 237.405 142.721V143.796C237.405 146.892 239.3 150.504 241.626 151.88Z",
    fill: "#CFD8DB"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M241.626 186.279L371.037 260.884C373.363 262.217 375.257 260.798 375.257 257.702V256.627C375.257 253.531 373.363 249.919 371.037 248.543L241.626 173.938C239.3 172.605 237.405 174.024 237.405 177.12V178.195C237.405 181.291 239.3 184.903 241.626 186.279Z",
    fill: "#CFD8DB"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M369.186 163.017C369.918 169.424 372.287 176.561 376.249 183.484C380.211 190.407 385.206 195.997 390.374 199.824L397.437 212.122L404.844 207.822C414.62 202.103 414.62 183.699 404.844 166.715C395.068 149.73 379.177 140.571 369.401 146.29L361.994 150.59L369.143 163.017H369.186Z",
    fill: "url(#paint8_linear_6128_38784)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M397.48 171.015C407.256 187.999 407.256 206.403 397.48 212.122C387.704 217.841 371.813 208.682 362.037 191.697C352.261 174.713 352.261 156.309 362.037 150.59C371.813 144.871 387.704 154.03 397.48 171.015Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M394.121 172.949C402.045 186.752 402.045 201.673 394.121 206.317C386.197 210.961 373.32 203.522 365.353 189.762C357.429 175.959 357.429 161.039 365.353 156.395C373.277 151.751 386.154 159.19 394.121 172.949Z",
    fill: "#00D158"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M380.039 195.094L377.541 196.556C377.541 196.556 377.756 196.427 377.842 196.341L380.34 194.879C380.34 194.879 380.125 195.051 380.039 195.094Z",
    fill: "#C6C0D0"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M362.898 173.422L365.396 171.96C366.258 171.444 367.377 171.616 368.497 172.261C369.53 172.863 370.564 173.895 371.425 175.228L368.928 176.69C368.109 175.357 367.033 174.325 365.999 173.723C364.879 173.078 363.76 172.906 362.898 173.422Z",
    fill: "#D3E1FC"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M368.928 176.69L371.426 175.228L376.034 182.667L373.536 184.129L368.928 176.69Z",
    fill: "#D3E1FC"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M390.59 186.021L393.045 184.559L380.384 194.879L377.886 196.341L390.59 186.021Z",
    fill: "#D3E1FC"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M384.087 175.572L386.585 174.11C387.446 173.637 388.566 173.766 389.685 174.411L387.188 175.873C386.068 175.228 384.905 175.056 384.087 175.572Z",
    fill: "#D3E1FC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M387.23 175.873L389.728 174.411C390.719 174.97 391.709 175.916 392.484 177.163C394.336 180.001 394.595 183.312 393.044 184.559L390.547 186.021C392.097 184.774 391.838 181.463 389.987 178.625C389.168 177.378 388.178 176.432 387.23 175.873Z",
    fill: "#D3E1FC"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M387.231 175.873C388.221 176.432 389.212 177.378 389.987 178.625C391.839 181.463 392.097 184.774 390.547 186.021L377.885 196.341C376.852 197.158 375.388 197.072 373.88 196.212C372.674 195.524 371.426 194.32 370.435 192.729L363.028 180.818C361.219 177.937 361.09 174.669 362.726 173.551C363.588 172.949 364.793 173.078 365.999 173.766C367.033 174.368 368.066 175.4 368.928 176.733L373.536 184.172L383.828 175.787C384.69 175.099 385.939 175.185 387.231 175.916V175.873Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M308.549 362.019C307.817 362.449 307.817 363.094 308.549 363.524L316.042 367.867C316.775 368.297 317.937 368.297 318.626 367.867L331.89 360.213C332.623 359.783 332.623 359.138 331.89 358.708L324.397 354.365C323.665 353.935 322.502 353.935 321.813 354.365L308.549 362.019Z",
    fill: "#E9EAED"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M308.549 363.524L310.142 364.47L321.813 357.762C322.545 357.332 323.708 357.332 324.397 357.762L330.297 361.159L331.89 360.256C332.623 359.826 332.623 359.181 331.89 358.751L324.397 354.408C323.665 353.978 322.502 353.978 321.813 354.408L308.549 362.062C307.817 362.492 307.817 363.137 308.549 363.567V363.524Z",
    fill: "#888B90"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_6128_38784",
    x: -20.5,
    y: 185.5,
    width: 681,
    height: 489,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 80
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.792157 0 0 0 0 0.8 0 0 0 0 0.870588 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6128_38784"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6128_38784",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -30
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.701961 0 0 0 0 0.756863 0 0 0 0 0.866667 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6128_38784"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_6128_38784",
    result: "effect3_innerShadow_6128_38784"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6128_38784",
    x1: 305.19,
    y1: 387.517,
    x2: 332.646,
    y2: 339.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#E8E8E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#D1D1D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C9C9CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6128_38784",
    x1: 409.064,
    y1: 327.232,
    x2: 487.005,
    y2: 192.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#818489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7B9BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6128_38784",
    x1: 220.912,
    y1: 250.564,
    x2: 421.572,
    y2: 134.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#BBBDBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#C7C9CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6128_38784",
    x1: 298.773,
    y1: 205.715,
    x2: 424.471,
    y2: 133.009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#989A9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7B9BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6128_38784",
    x1: 269.015,
    y1: 133.304,
    x2: 392.862,
    y2: 61.7178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#818489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#B7B9BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6128_38784",
    x1: 225.82,
    y1: 237.32,
    x2: 410.171,
    y2: 130.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BAEFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6128_38784",
    x1: 308.075,
    y1: 312.741,
    x2: 311.298,
    y2: 307.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#BDC8E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAECEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6128_38784",
    x1: 264.709,
    y1: 281.007,
    x2: 350.04,
    y2: 133.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAECEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6128_38784",
    x1: 408.332,
    y1: 205.844,
    x2: 372.885,
    y2: 144.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#A7D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E3ECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#E0EBF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#D9E7F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#CDE2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#BBDAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D9FC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6128_38784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 660,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6128_38784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263,
    height: 414,
    fill: "white",
    transform: "translate(189 20)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigital);
export default __webpack_public_path__ + "static/media/digital.e656c092a347a56bc15ef8cadbde71e7.svg";
export { ForwardRef as ReactComponent };